import * as React from 'react'
import { Link } from 'react-router-dom'
import { IMobilityOptionObject } from '../../types/index'
import EditIcon from '../icons/ui/Edit'
import Trash from '../icons/ui/Trash'
import ContextMenu from '../ui/ContextMenu'

export interface IMobilityOptionsListItemProps {
  mobilityOption: IMobilityOptionObject
}

const MobilityOptionsListItem = ({ mobilityOption }: IMobilityOptionsListItemProps) => {
  return (
    <div className='mb3'>
      <div className='flex pl3'>
        <div className='col-3'>
          <span className='MobilityOptionsListItemCategory'>{mobilityOption.categoryId}</span>
        </div>
        <div className='col-3'>
          <span className='MobilityOptionsListItemName'>{mobilityOption.name}</span>
        </div>
        <div className='col-3'>Yes</div>
        <div className='col-3'>
          <div className='ml3'>
            <ContextMenu>
              <div className='MenuItem flex cursor--pointer'>
                <Link to={``}>
                  <EditIcon className='icon--small svg-stroke-grey3 mr1' />
                  <span className='font-dark-grey'>Edit</span>
                </Link>
              </div>
              <div className='MenuItem flex cursor--pointer'>
                <Link to={``}>
                  <Trash className='icon--small svg-stroke-grey3 mr1' />
                  <span className='font-dark-grey'>Remove</span>
                </Link>
              </div>
            </ContextMenu>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobilityOptionsListItem



// WEBPACK FOOTER //
// ./src/components/mobility-options/MobilityOptionsListItem.tsx